import React, { useMemo, useState } from "react";
import LoadingSpinner from "./spinner";
import CelluleUrlSite from "./celluleUrlSite";
import getInfoThemeActif from "./infoThemeActif";
import "../style/drawer.scss";
import "../style/itemsList.scss";
import TableFTP from "./TableFTP";
import PluginDetailsDrawer from "./PluginFTP";
import SiteFilter from "./SiteFilter";
import ClientFilter from "./ClientFilter";
import InstanceFilter from "./InstanceFilter";
import "../style/filter.scss";
import "../style/btn.scss";
import "../style/wp.scss";
import { exportSitesToExcel } from "../utils/exportToExcel";
import CompareDrawer from "./CompareDrawer";
import BasicButtons from "./buttonChoice";
import { Box, useTheme } from "@mui/material";


const FTPComponentSite = ({ filteredData, cveList, handleSort, role, isLoading, error, handlePluginButtonClick, handleSiteButtonClick,handleThemeButtonClick,handleCVEButtonClick}) => {
  const theme = useTheme();
  const [selectedFilteredIndex, setSelectedFilteredIndex] = useState(null);
  const [selectedCounterpartIndex, setSelectedCounterpartIndex] = useState(null);
  const [filterSite, setFilterSite] = useState("all");
  const [filterClient, setFilterClient] = useState("all");
  const [filterInstance, setFilterInstance] = useState("all");

  // Mémoïsés et placés avant les early returns : le state d'ouverture des drawers vit
  // ici, donc sans ça chaque clic sur une ligne reclonait tout le dataset des sites
  // (spread par élément) dans la frame même où le Drawer démarre son animation.
  const filteredDataWithIndices = useMemo(
    () =>
      (Array.isArray(filteredData) ? filteredData : []).map((item, index) => ({
        ...item,
        originalIndex: index,
      })),
    [filteredData]
  );

  const filteredDataByBoth = useMemo(
    () =>
      filteredDataWithIndices.filter(
        (item) =>
          (filterSite === "all" || item.content.name === filterSite) &&
          (filterClient === "all" ||
            item.content["selected-service"] === filterClient) &&
          (filterInstance === "all" ||
            item.content.environnement === filterInstance)
      ),
    [filteredDataWithIndices, filterSite, filterClient, filterInstance]
  );

  const handleRowClick = (filteredIndex) => {
    setSelectedFilteredIndex(filteredIndex);
  };

const handleCompare = (filteredIndex) => {
  setSelectedFilteredIndex(filteredIndex);
  const idx = typeof filteredIndex === "number" ? filteredIndex : selectedFilteredIndex;
  if (idx === null || typeof idx !== "number") return;

  const currentItem = filteredDataByBoth[idx];
  if (!currentItem) return;

  const siteName = (currentItem.content.name || "").toString().toLowerCase().trim();

  if(currentItem.content.environnement === "REC"){
    
    const recItem = filteredDataWithIndices.find(
      (it) =>
        (it.content.name || "").toString().toLowerCase().trim() === siteName &&
        (it.content.environnement || "").toString().toLowerCase().trim() === "prd"
    );

  if (!recItem) {
    setSelectedCounterpartIndex(null);
    return;
  }

  setSelectedCounterpartIndex(recItem.originalIndex)
}
else if(currentItem.content.environnement === "PRD"){
    const recItem = filteredDataWithIndices.find(
      (it) =>
        (it.content.name || "").toString().toLowerCase().trim() === siteName &&
        (it.content.environnement || "").toString().toLowerCase().trim() === "rec"
    );


  if (!recItem) {
    setSelectedCounterpartIndex(null);
    return;
  }

  setSelectedCounterpartIndex(recItem.originalIndex);
  };
}


  const handleFilterChange = (siteName) => {
    setFilterSite(siteName);
  };

  const handleFilterClientChange = (clientName) => {
    setFilterClient(clientName);
  };

  const handleFilterInstanceChange = (instanceName) => {
    setFilterInstance(instanceName);
  };

  const handleCloseDrawer = () => {
    setSelectedFilteredIndex(null);
  };

  const handleCloseCompareDrawer = () => {
    setSelectedFilteredIndex(null);
    setSelectedCounterpartIndex(null);
  };

  const handleDownloadExcel = () => {
    const filteredDataToExport = filteredDataByBoth.map((item) => item.content);

    exportSitesToExcel(filteredDataToExport, "filtered_sites_data");
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner role={role} />
      </div>
    );
  }

  if (error) {
    return <div>Erreur lors de la récupération des données FTP</div>;
  }

  // Le backend filtre déjà les sites selon le viewRole
  // Pas besoin de filtrage supplémentaire ici
  const siteFilterData = filteredDataWithIndices;

  return (
    <>
  <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%", justifyContent: "space-between", }}>
    <BasicButtons
          place="site"
          onSiteButtonClick={handleSiteButtonClick}
          onPluginButtonClick={handlePluginButtonClick}
          onThemeButtonClick={handleThemeButtonClick}
          onCVEButtonClick={handleCVEButtonClick}
          handleFilterClientChange={handleFilterClientChange}
          handleFilterInstanceChange={handleFilterInstanceChange}
          role={role}
    />
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}
    >
      <SiteFilter
          data={siteFilterData}
          onFilterChange={handleFilterChange}
          sx={{
            backgroundColor: theme.palette.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.1)'
              : "rgba(255, 255, 255, 0.5)",
            "&:hover": {
              backgroundColor: theme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.15)'
                : "rgba(255, 255, 255, 0.7)",
            },
            ".MuiSelect-select": {
              "&:focus": {
                backgroundColor: theme.palette.mode === 'dark'
                  ? 'rgba(255, 255, 255, 0.1)'
                  : "rgba(255, 255, 255, 0.5)",
              },
            },
          }}
          role={role}
        />
        {role === "admin" && (
            <ClientFilter
              data={filteredData}
              onFilterChange={handleFilterClientChange}
              sx={{
                borderRadius:2,
                backgroundColor: theme.palette.mode === 'dark'
                  ? 'rgba(255, 255, 255, 0.1)'
                  : "rgba(255, 255, 255, 0.5)",
                "&:hover": {
                  backgroundColor: theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.15)'
                    : "rgba(255, 255, 255, 0.7)",
                },
                ".MuiSelect-select": {
                  "&:focus": {
                    backgroundColor: theme.palette.mode === 'dark'
                      ? 'rgba(255, 255, 255, 0.1)'
                      : "rgba(255, 255, 255, 0.5)",
                  },
                },
              }}
              role={role}
            />
        )}
      <InstanceFilter
        data={filteredData}
        onFilterChange={handleFilterInstanceChange}
        sx={{
          borderRadius:2,
          backgroundColor: theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, 0.1)'
            : "rgba(255, 255, 255, 0.5)",
          "&:hover": {
            backgroundColor: theme.palette.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.15)'
              : "rgba(255, 255, 255, 0.7)",
          },
          ".MuiSelect-select": {
            "&:focus": {
              backgroundColor: theme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.1)'
                : "rgba(255, 255, 255, 0.5)",
            },
          },
        }}
        role={role}
      />
      </Box>
    </Box>
      <TableFTP
        data={filteredDataByBoth}
        handleSort={handleSort}
        handleRowClick={handleRowClick} // Pass filtered index directly
        handleCompare={handleCompare}
        CelluleUrlSite={CelluleUrlSite}
        getInfoThemeActif={getInfoThemeActif}
        handleDownloadExcel={handleDownloadExcel}
        role={role}
      />

      {selectedFilteredIndex !== null && selectedCounterpartIndex == null && (
        <PluginDetailsDrawer
          selectedFilteredIndex={selectedFilteredIndex}
          handleCloseDrawer={handleCloseDrawer}
          filteredData={filteredDataByBoth} // Pass filtered data
          cveList={cveList}
          role={role}
        />
      )}

      {selectedCounterpartIndex !== null && (
        <CompareDrawer
          selectedFilteredIndex={selectedFilteredIndex}
          selectedRecCounterpart={selectedCounterpartIndex}
          handleCloseDrawer={handleCloseCompareDrawer}
          filteredData={filteredDataByBoth}
          originalData={filteredDataWithIndices} // On donne la liste avant le filtrage de manière à pouvoir récupérer le complémentaire, même s'il n'est pas affiché dans la tableau
          role={role}
        />
      )}
    </>
  );
};

export default FTPComponentSite;
